<template>
	<div class="categories-filter-container" :class="{hidden: selectedCategories.length === 0}">
		<div class="category" :class="{active: activeCategory === category.menu_category_id}" v-for="category in selectedCategories" :key="category.menu_category_id" @click="toggleCategory(category)">
			<p>{{ categoryDisplayName( category.name ) }}</p>
		</div>
	</div>
</template>

<script>
import {useMenuStore, } from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";

export default {
	setup() {
		const menuStore = useMenuStore();
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {menuStore, getString: languageStore.getString, userStore, notificationStore};
	},
	name: "CategoriesFilter",
	emits: ["select-category"],
	props: {
		selectedCategories: {type: Array, required: true},
	},
	data() {
		return {
			activeCategory: null,
		}
	},
	methods: {
		toggleCategory(category) {
			if (this.activeCategory === category.menu_category_id) {
				this.activeCategory = null;
			} else {
				this.activeCategory = category.menu_category_id;
			}
			this.$emit("select-category", this.activeCategory);
		},
		categoryDisplayName( name ) {
			return ( name !== "" ? name : this.getString('no_name_cat') );
		},
	},
}
</script>

<style lang="scss" scoped>
.categories-filter-container {
	border-radius: 13px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 8px;
	gap: 6px;
	width: 100%;
	height: 66px;

	.category {
		border-radius: 13px;
		border: 1px solid var(--color-primary);
		padding: 0 12px;
		cursor: pointer;
		user-select: none;
		transition: background-color 0.3s ease;
		height: 54px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		min-width: 120px;
		max-width: 250px;

		@media (max-width: 950px) {
			min-width: 110px;
		}

		@media (max-width: 850px) {
			min-width: 95px;
		}

		@media (max-width: 750px) {
			min-width: 110px;
		}

		@media (max-width: 550px) {
			min-width: 95px;
		}

		p {
			font-size: 16px;
			color: var(--color-primary);
			@include truncateString(1);
		}

		&.active {
			background-color: var(--color-active-button);
			p {
				color: var(--color-active-button-text);
			}
		}
	}

	@media (max-width: 900px) {
		padding: 8px;
		gap: 8px;
		min-height: 56px;

		.category {
			padding: 0 8px;
		}
	}

}
</style>